import { IFormItem } from '@components/Form/FormItem/FormItem';
import { Validators } from '@components/Form/FormItem/FormItemValidation';

import { IndividualShort } from '@/api/vaccination/registry/types';

export const addModalConfig = (
  individuals: IndividualShort[],
  indivWithLocation: Set<string>,
) =>
  [
    {
      label: 'Инвентарный номер',
      key: 'individualId',
      type: 'select',
      payload: {
        options: individuals
          ?.map((value: IndividualShort) => {
            if (indivWithLocation.has(value.inventoryNumber)) {
              return null;
            }
            return {
              label: value.inventoryNumber,
              value: value.id,
            };
          })
          .filter(Boolean),
        showSearch: true,
      },
      placeholder: 'Выберите инвентарный номер особи',
      validation: [Validators.required()],
    },
  ] as IFormItem[];
